import React, { useState, useMemo, useCallback, useContext, useEffect } from 'react';
import { Img } from '../../../hybrid/wrappers';
import { dataSender } from '../../../common/utils/router';
import UserContext, { UserProfileContext } from '../../../common/utils/getContext';
import { changeTableItemsLengthFuncSort } from './utils';
import { useWindowDimensions } from '../../../common/utils/windowDimensions';
import { declOfNum } from '../../../common/utils/utils';
import T from '../../../common/components/T';
import DropdownElement from '../../../hybrid/library/DropdownElement';
import filterIcon from '../../../public/src/img/store/filterIcon.svg';
import classNames from 'classnames';

const StoreProductHeader = ({
    compStyles,
    setProductData,
    setFilterMobile,
    countProduct,
    // selectedLengthItems,
    // setSelectedLengthItems,
    // selectPageItems,
    selectPageItemsSort,
    setSelectedSortItems,
    selectedSortItem,
    getUrl
}) => {
    const widthDimensions = useWindowDimensions();
    const [mobile, setMobile] = useState('');
    useEffect(() => {
        widthDimensions < 992 ? setMobile(true) : setMobile(false);
    }, [widthDimensions]);
    const { localization, setAlertData, userToken, lang } = useContext(UserContext);
    const { profileData } = useContext(UserProfileContext);

    const chamgeTableItemsLengthSort = useCallback(
        (data) => {
            setSelectedSortItems(data.value || data.id);
            changeTableItemsLengthFuncSort(
                data.value || data.id,
                dataSender,
                setProductData,
                setAlertData,
                userToken,
                lang,
                localization?.currency,
                getUrl(),
                profileData
            );
        },
        [setProductData, setSelectedSortItems, setAlertData, userToken, lang, getUrl, localization?.currency, profileData]
    );

    // const chamgeTableItemsLength = useCallback(
    //     (data) => {
    //         setSelectedLengthItems(data.value);
    //         changeTableItemsLengthFunc(
    //             data.value,
    //             dataSender,
    //             setProductData,
    //             setAlertData,
    //             userToken,
    //             lang,
    //             localization?.currency,
    //             getUrl()
    //         );
    //     },
    //     [setSelectedLengthItems, setProductData, setAlertData, userToken, lang, getUrl, localization?.currency]
    // );

    const selectPageConfigSort = useMemo(
        () => ({
            className: 'adminTableFilterSelectSort',
            controlClassName: 'adminTableFilterSelect-dropdown-control',
            arrowClassName: 'adminTableFilterSelect-dropdown-arrow',
            options: selectPageItemsSort,
            value: selectedSortItem,
            onChange: chamgeTableItemsLengthSort
        }),
        [chamgeTableItemsLengthSort, selectedSortItem, selectPageItemsSort]
    );
    // const selectPageConfig = useMemo(
    //     () => ({
    //         className: 'adminTableFilterSelect',
    //         controlClassName: 'adminTableFilterSelect-dropdown-control',
    //         arrowClassName: 'adminTableFilterSelect-dropdown-arrow',
    //         options: selectPageItems,
    //         value: selectedLengthItems,
    //         onChange: chamgeTableItemsLength
    //     }),
    //     [selectedLengthItems, selectPageItems, chamgeTableItemsLength]
    // );

    return (
        <div className={compStyles.storeProductHeader}>
            {mobile && 0 ? (
                <div className={compStyles.storeProductHeaderFilterMobile}>
                    <div>
                        <div className={compStyles.selectPageWrap}>
                            <DropdownElement componentConfig={selectPageConfigSort} />
                        </div>
                    </div>
                    <div onClick={() => setFilterMobile(true)} className={compStyles.storeProductHeaderFilterIcon}>
                        <Img src={filterIcon} />
                        {/*{svgSprite('sort-down', {*/}
                        {/*    style: {*/}
                        {/*        width: '18px',*/}
                        {/*        height: '18px'*/}
                        {/*    }*/}
                        {/*})}*/}
                    </div>
                </div>
            ) : (
                <div className={compStyles.storeProductHeaderFilter}>
                    <div>
                        {countProduct > 0 && (
                            <div>
                                <T textName='selected' defaultStr='Выбрано' page='all' /> {countProduct}{' '}
                                {declOfNum(countProduct, [
                                    <T
                                        key={'declOfNum-product-1'}
                                        textName='store-inBasket-product'
                                        defaultStr='товар'
                                        page='/store'
                                    />,
                                    <T
                                        key={'declOfNum-product-2'}
                                        textName='store-inBasket-product2'
                                        defaultStr='товара'
                                        page='/store'
                                    />,
                                    <T
                                        key={'declOfNum-product-3'}
                                        textName='store-inBasket-product3'
                                        defaultStr='товаров'
                                        page='/store'
                                    />
                                ])}
                            </div>
                        )}
                    </div>
                    <div className={compStyles.storeProductHeaderFilterDrop}>
                        {/* <div>
                            <div className={compStyles.selectPageWrap}>
                                <p className={compStyles.selectPageText} key={generateUniqueId()}>
                                    <T textName='store-EntriesPerPage' defaultStr='Записей на странице' page='/store' />:
                                </p>
                                <DropdownElement componentConfig={selectPageConfig} />
                            </div>
                        </div> */}
                        <p className={compStyles.filterLabel}>
                            <T textName='show-first' defaultStr='Показывать сначала' page='/store' />:
                        </p>
                        {selectPageItemsSort.map((option) => (
                            <p
                                onClick={() => chamgeTableItemsLengthSort(option)}
                                key={option.value}
                                className={classNames(compStyles.filterItem, {
                                    [compStyles.filterItemSelected]: option.value === selectedSortItem
                                })}
                            >
                                {option.label}
                            </p>
                        ))}
                        {/* <div>
                            <div className={compStyles.selectPageWrap}>
                                <DropdownElement componentConfig={selectPageConfigSort} />
                            </div>
                        </div> */}
                    </div>
                </div>
            )}
        </div>
    );
};
export default StoreProductHeader;
